import { Modal, Form, Input, Select, Upload, message, Button } from 'antd';
import { useEffect, useState } from 'react';
import { SessionStorage } from '../../services/storage';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import React from 'react';
import { useOperationStore } from '../../stores/OperationStore';
import { CANCEL_PICKUP_FILE, TWO_HUNDRED_SUCCESS_CODE } from '../../utils/app-common';
import { UploadOutlined } from '@ant-design/icons';


const PickUpCancelPopup = ({ visible, onClose, data }) => {
    const [form] = Form.useForm();
    const { exceptionList } = JSON.parse(
        SessionStorage.get("app-storage") ?? "{}"
    );
    const PickUpCancelRequestAction = useOperationStore((state) => state?.PickUpCancelRequestAction);

    const { promiseInProgress: pickupCancelInprogress } = usePromiseTracker({ area: 'pickup-cancel-request-area' });


    const beforeUpload = (file) => {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            message.error('File must be smaller than 5MB!');
            return Upload.LIST_IGNORE;
        }
        return false;
    };



    const handleOk = async (values) => {
        try {
            const payload = {
                waybillNo: data?.waybillNo,
                bookingId: data?.id,
                exceptionId: values?.exceptionId,
                remarks: values?.remarks,
                fromSource: "WEB",
                category: CANCEL_PICKUP_FILE,
                fileType: CANCEL_PICKUP_FILE,
                file: values?.pdfFile?.[0]?.originFileObj,
                fileFormat: values?.pdfFile?.[0]?.type,
            }
            const res = await trackPromise(PickUpCancelRequestAction(payload));
            if (res?.status === TWO_HUNDRED_SUCCESS_CODE && res?.data?.statusCode === TWO_HUNDRED_SUCCESS_CODE) {
                onClose();
            }
        } catch (info) {
            console.log('Validate Failed:', info);
        }
    };

    useEffect(() => {
        if (!visible) {
            form.resetFields();
        }
        //eslint-disable-next-line
    }, [visible]);

    return (
        <Modal
            title={`PickupCancel Request - ${data?.waybillNo}`}
            visible={visible}
            onOk={form.submit}
            onCancel={onClose}
            width={600}
            confirmLoading={pickupCancelInprogress}
            maskClosable={false}
        >
            <Form form={form} layout="vertical" onFinish={handleOk} onFinishFailed={(errorInfo) => console.log('Failed:', errorInfo)} >
                <Form.Item
                    name="exceptionId"
                    label="Reason"
                    rules={[{ required: true, message: 'Please select an option!' }]}
                >
                    <Select placeholder="Select an option" >
                        {exceptionList?.map((exception) => (
                            <React.Fragment key={exception?.exceptionId}>
                                <Select.Option value={exception?.exceptionId}>
                                    {exception?.exception}
                                </Select.Option>
                            </React.Fragment>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="remarks"
                    label="Remarks"
                >
                    <Input.TextArea rows={4} placeholder="Enter remarks with a maximum of 150 characters" maxLength={150} />
                </Form.Item>
                <Form.Item
                    name="pdfFile"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
                // rules={[{ required: true, message: 'Please upload a PDF file!' }]}
                >
                    <Upload
                        name="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        beforeUpload={beforeUpload}
                        maxCount={1}
                        style={{ width: '100%' }}
                    >
                        <Button icon={<UploadOutlined />}>Click to upload</Button>
                    </Upload>
                </Form.Item>
            </Form>
        </Modal>
    );
};


export default PickUpCancelPopup;